import React from 'react';
import Header from "./Header/header";
import HowItWorks from './HowItWorks/howItWorks';
import Banner from './Banner/banner';
import Uses from './Uses/uses';
import FrequentlyAskedQuestions from './FAQs/frequentlyAskedQuestions';
import Footer from '../Footer/footer';
import LoanExample from './LoanExample/loanExample';
import WhoWeAre from './WhoWeAre/whoWeAre';
import Benefits from './Benefits/benefits';
import FloatingForm from "./FloatingForm/floatingForm";
import { getCampaignFromEnvConfig, getFeatureToggle } from "../../selectors";
import { marketCodeChanged } from "../../actions";
import { MarketCodes } from "../../marketCodes";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

export class NoInvitationLandingPage extends React.Component {

  componentDidMount() {
    this.props.marketCodeChanged(MarketCodes.OPEN_MARKET);
  }

  render() {
    return (
      <article>
        <Header/>
        <Banner campaignData={this.props.campaignData} />
        <FloatingForm/>
        <HowItWorks/>
        <Benefits/>
        <Uses/>
        <LoanExample campaignData={this.props.campaignData} />
        <FrequentlyAskedQuestions campaignData={this.props.campaignData} openMarketFAQChanges={this.props.openMarketFAQChanges} />
        <WhoWeAre campaignData={this.props.campaignData} />
        <Footer/>
      </article>
    );
  }
}

NoInvitationLandingPage.propTypes = {
  marketCodeChanged: PropTypes.func.isRequired,
  campaignData: PropTypes.object,
  openMarketFAQChanges: PropTypes.bool
};

const mapStateToProps = (state) => ({
  campaignData: getCampaignFromEnvConfig(state),
  openMarketFAQChanges: getFeatureToggle(state, 'open_market_faq_changes')
});

const mapDispatchToProps = { marketCodeChanged };

export default connect(mapStateToProps, mapDispatchToProps)(NoInvitationLandingPage);
